/**
 * Tournament date/time inputs are always interpreted as UTC (see utcTooltip in UI).
 */

export function parseUtcTimestamp(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  if (s.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(s)) {
    return new Date(s);
  }
  return new Date(s.includes('T') ? `${s}Z` : `${s}T00:00:00.000Z`);
}

export function buildUtcDateTime(dateStr, timeStr) {
  const time = timeStr || '00:00';
  const normalizedTime = time.length === 5 ? `${time}:00` : time;
  return new Date(`${dateStr}T${normalizedTime}.000Z`);
}

export function formatUtcTime(date) {
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function formatUtcDate(date) {
  return date.toISOString().substr(0, 10);
}
